import React, { useEffect, useRef, useState } from "react";

import {
    Box,
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    Popper,
    ClickAwayListener,
    ToggleButtonGroup,
    ToggleButton,
    Drawer,
    FormControl,
    InputLabel,
    Select,
    Input,
    IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BedroomChildIcon from "@mui/icons-material/BedroomChild";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Unstable_Grid2";
import { config, styles } from "../../style";
import "./style.css";

import { getLocation } from "../../services/google";
import RangeSlider from "../RangeSlider";
import { convertNumberToShort } from "../../utils";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter.svg";
import { Checklist } from "../Checklist";
import { RangePicklist } from "../RangePicklist";

const Filters = (props) => {
    const { records, propertyCount, markets, selectedMarketRecord, existingFilters } = props;
    const [displayAllFilter, setDisplayAllFilter] = React.useState(false);
    const [anchorMarketEl, setAnchorMarketEl] = React.useState(null);
    console.log("selectedMarketRecord", selectedMarketRecord?.name);
    const [filter, setFilter] = React.useState({ market: selectedMarketRecord?.name, bedsFilter: "", bathsFilter: "" });
    const [localFilter, setLocalFilter] = React.useState({
        market: selectedMarketRecord?.name,
        bedsFilter: "",
        bathsFilter: "",
    });
    const [selectOpen, setSelectOpen] = React.useState({});
    const marketOpen = Boolean(anchorMarketEl);

    const [anchorPriceRangeEl, setAnchorPriceRangeEl] = React.useState(null);
    const priceRangeOpen = Boolean(anchorPriceRangeEl);

    const [anchorBedBathEl, setAnchorBedBathEl] = React.useState(null);
    const bedBathOpen = Boolean(anchorBedBathEl);

    const [anchorStatusEl, setAnchorStatusEl] = React.useState(null);
    const statusOpen = Boolean(anchorStatusEl);

    const [anchorLeaseProductEl, setAnchorLeaseProductEl] = React.useState(null);
    const leaseProductOpen = Boolean(anchorLeaseProductEl);

    let filterRef = useRef(filter);

    const navigate = useNavigate();
    useEffect(() => {
        let filterData = { ...filter };
        filterData.market = selectedMarketRecord?.name;
        filterRef.current = filterData;
        setFilter((filter) => filterData);
    }, [selectedMarketRecord]);

    useEffect(() => {
        let filterData = { ...filter };
        filterRef.current = { ...filterData, ...existingFilters };
        setFilter((filter) => {
            return { ...filterData, ...existingFilters };
        });
    }, [existingFilters]);

    const getAmenityAndFeaturesOptions = () => {
        let options = [];
        let uniqueArray = [];
        for (let record of records) {
            if (record.amenityAndFeatures?.length > 0) {
                for (let amenity of record.amenityAndFeatures) {
                    if (uniqueArray.indexOf(amenity.name.toLowerCase()) === -1) {
                        options.push({ label: amenity.name, value: amenity.name });
                        uniqueArray.push(amenity.name.toLowerCase());
                    }
                }
            }
        }

        return options;
    };

    const [amenityAndFeaturesOptions, setAmenityAndFeaturesOptions] = React.useState(
        getAmenityAndFeaturesOptions(records)
    );

    const handleMarketMenuClick = (event) => {
        handleClickAway();
        setAnchorMarketEl(event.currentTarget);
    };

    const handleStatusMenuClick = (event) => {
        handleClickAway();
        setAnchorStatusEl(event.currentTarget);
    };

    const handleLeaseProductMenuClick = (event) => {
        handleClickAway();
        setAnchorLeaseProductEl(event.currentTarget);
    };

    const handlePriceRangeClick = (event) => {
        handleClickAway();
        setAnchorPriceRangeEl(event.currentTarget);
    };

    const handleBedBathClick = (event) => {
        handleClickAway();
        setAnchorBedBathEl(event.currentTarget);
    };

    const handleMarketMenuClose = async (value) => {
        let data = {
            ...filter,
            market: value,
        };
        filterRef.current = data;
        setFilter((filter) => data);
        if (value) {
            console.log("value", value);
            //Let's find the geolocationname for this market
            let selectedMarket = markets.find((item) => item.name === value);
            navigate("/listing-search/markets/" + selectedMarket.id);
            let location = await getLocation(selectedMarket.geoLocationName);
            props.onLocationChange(location, selectedMarket.geoLocationName);
        }
        setAnchorMarketEl(null);
        props.onChange(data);
    };

    const callLocationChange = async () => {
        let selectedMarket = markets.find((item) => item.name === filterRef.current.market);
        let location = await getLocation(selectedMarket.geoLocationName);
        props.onLocationChange(location, selectedMarket.geoLocationName);
    };

    const handleStatusClose = async (value) => {
        let data = {
            ...filter,
            status: value,
        };
        filterRef.current = data;

        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
    };

    const handleLeaseProductClose = (value) => {
        let data = {
            ...filter,
            leaseProduct: value,
        };
        filterRef.current = data;
        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
    };

    const handlePriceRangeClose = () => {
        setAnchorPriceRangeEl(null);
    };

    const getMarketFilters = () => {
        if (markets) {
            let tempMarkets = [...markets];
            tempMarkets.sort((a, b) => a.order - b.order);
            return tempMarkets.map((item) => item.name);
        }
        let marketData = [];
        for (let record of records) {
            if (record.publicMarketLabel && marketData.indexOf(record.publicMarketLabel) === -1) {
                marketData.push(record.publicMarketLabel);
            }
        }
        return marketData;
    };

    const getStatusFilters = () => {
        let statusData = [
            { value: "Coming Soon", label: "Coming Soon" },
            { value: "Available Now", label: "Available Now" },
        ];

        return statusData;
    };

    const getLeaseProductFilters = () => {
        let leaseProductData = [
            { value: "Rent to Own", label: "Rent to Own" },
            { value: "12-Month Rental", label: "12-Month Rental" },
        ];

        return leaseProductData;
    };

    const handleClickAway = () => {
        setAnchorPriceRangeEl(null);
        setAnchorMarketEl(null);
        setAnchorBedBathEl(null);
        setAnchorStatusEl(null);
        setAnchorLeaseProductEl(null);
    };

    const handlePriceRangeChange = (event, newValue) => {
        let data = {
            ...filter,
            priceFilter: newValue,
        };
        filterRef.current = data;
        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
    };

    const handleBedsChange = (event, newValue) => {
        let data = {
            ...filter,
            bedsFilter: newValue,
        };
        filterRef.current = data;
        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
    };

    const handleBathsChange = (event, newValue) => {
        let data = {
            ...filter,
            bathsFilter: newValue,
        };
        filterRef.current = data;
        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
    };

    const handleClear = (event, filterValue) => {
        event.stopPropagation();
        let filterData = filter;
        if (filterValue === "bedsFilter") {
            filterData[filterValue] = "";
            filterData["bathsFilter"] = "";
        } else {
            filterData[filterValue] = undefined;
        }

        filterRef.current = {
            ...filterData,
        };
        setFilter((filter) => ({
            ...filterData,
        }));
        callLocationChange();
        props.onChange(filterData);

        handleClickAway();
    };

    const handleLocalFilterChange = (event, value, filter) => {
        event.stopPropagation();
        event.preventDefault();
        let data = {
            ...localFilter,
        };
        data[filter] = value;

        setLocalFilter((filter) => data);
        handleSelectClose();
    };

    const handleCancelLocalFilter = () => {
        setLocalFilter((filter) => ({ bedsFilter: "", bathsFilter: "" }));
        setDisplayAllFilter(false);
    };

    const handleResetAllFilter = () => {
        let newFilter = { ...filter };
        setLocalFilter((filter) => ({ market: newFilter.market, bedsFilter: "", bathsFilter: "" }));
        setFilter((filter) => ({ market: newFilter.market, bedsFilter: "", bathsFilter: "" }));
        filterRef.current = { market: newFilter.market, bedsFilter: "", bathsFilter: "" };
        callLocationChange();
        props.onChange({ market: newFilter.market, bedsFilter: "", bathsFilter: "" });
        setDisplayAllFilter(false);
    };

    const handleApplyLocalFilter = async () => {
        let data = {
            ...filter,
            ...localFilter,
        };
        // if (filter.market !== localFilter.market) {
        //     if (localFilter.market) {
        //         let selectedMarket = markets.find((item) => item.name === localFilter.market);
        //         let location = await getLocation(selectedMarket.geoLocationName);
        //         props.onLocationChange(location, selectedMarket.geoLocationName);
        //     }
        // }
        filterRef.current = data;
        setFilter((filter) => data);
        callLocationChange();
        props.onChange(data);
        setDisplayAllFilter(false);
    };

    const handleSelectClick = (event, selectValue) => {
        event.stopPropagation();
        event.preventDefault();
        const data = {};
        data[selectValue] = true;
        setSelectOpen(data);
    };
    const handleSelectClose = () => {
        const data = {};
        setSelectOpen(data);
    };

    const getFilterCount = () => {
        let data = {
            ...filter,
        };

        let count = 0;

        for (let key of Object.keys(data)) {
            if (data[key]) {
                let value = data[key];
                if (typeof value == "object") {
                    if (Object.keys(value).length > 0) {
                        count++;
                    }
                } else {
                    count++;
                }
            }
        }

        return count;
    };

    const getSquareFtOptions = () => {
        return [
            { value: "750", label: "750" },
            { value: "1000", label: "1,000" },
            { value: "1100", label: "1,100" },
            { value: "1200", label: "1,200" },
            { value: "1300", label: "1,300" },
            { value: "1400", label: "1,400" },
            { value: "1500", label: "1,500" },
            { value: "1600", label: "1,600" },
            { value: "1700", label: "1,700" },
            { value: "1800", label: "1,800" },
            { value: "1900", label: "1,900" },
            { value: "2000", label: "2,000" },
            { value: "2250", label: "2,250" },
            { value: "2500", label: "2,500" },
            { value: "2750", label: "2,750" },
            { value: "3000", label: "3,000" },
            { value: "4000", label: "4,000" },
            { value: "5000", label: "5,000" },
            { value: "7000", label: "7,000" },
            { value: "10000", label: "10,000" },
        ];
    };

    const getLotSqFTOptions = () => {
        return [
            { value: "2000", label: "2,000 sq ft" },
            { value: "4500", label: "4,500 sq ft" },
            { value: "6500", label: "6,500 sq ft" },
            { value: "8000", label: "8,000 sq ft" },
            { value: "9500", label: "9,500 sq ft" },
            { value: "10890", label: "0.25 acres" },
            { value: "21780", label: "0.5 acres" },
            { value: "43560", label: "1 acre" },
            { value: "87120", label: "2 acres" },
            { value: "130680", label: "3 acres" },
            { value: "174240", label: "4 acres" },
            { value: "217800", label: "5 acres" },
            { value: "435600", label: "10 acres" },
            { value: "871200", label: "20 acres" },
            { value: "1742000", label: "40 acres" },
            { value: "4356000", label: "100 acres" },
        ];
    };

    const getStoriesOptions = () => {
        return [
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "3", label: "3" },
            { value: "4", label: "4" },
            { value: "5", label: "5" },
            { value: "10", label: "10" },
            { value: "15", label: "15" },
            { value: "20", label: "20" },
        ];
    };

    const getYearBuildOptions = () => {
        let options = [];
        let year = new Date().getFullYear();
        for (let i = year; i >= 2010; i--) {
            options.push({ value: i, label: i });
        }
        return [
            ...options,
            { value: "2005", label: "2005" },
            { value: "2000", label: "2000" },
            { value: "1990", label: "1990" },
            { value: "1980", label: "1980" },
            { value: "1970", label: "1970" },
            { value: "1950", label: "1950" },
            { value: "1940", label: "1940" },
            { value: "1920", label: "1920" },
            { value: "1900", label: "1900" },
        ];
    };

    const handleAllFilterClick = () => {
        setDisplayAllFilter(true);
        let data = {
            ...filter,
        };

        setLocalFilter((filter) => data);
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className="Filters">
                <>
                    <Box
                        sx={{
                            mb: "20px",
                            flexDirection: "row",
                            alignItems: "center",
                            display: { xs: "none", md: "flex" },
                        }}>
                        <Grid container>
                            <Grid item sx={{ display: "flex" }}>
                                <Box className="filter1">
                                    <Button
                                        id="market-filter"
                                        aria-controls={marketOpen ? "basic-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-describedby="basic-menu"
                                        onClick={handleMarketMenuClick}
                                        sx={{ ...styles.outlinedButton }}
                                        className={filter?.market ? "selected" : ""}
                                        variant="outlined"
                                        endIcon={<KeyboardArrowDownIcon />}
                                        startIcon={<LocationOnIcon sx={{ color: config.primaryColor }} />}>
                                        {`${filter?.market ? filter.market : "Market"}`}
                                    </Button>
                                    <Popper
                                        sx={{
                                            ...styles.popper,
                                            minWidth: "100px",
                                            zIndex: "1000",
                                            p: "0",
                                        }}
                                        id="basic-menu"
                                        open={marketOpen}
                                        onClose={() => handleMarketMenuClose("")}
                                        anchorEl={anchorMarketEl}>
                                        {getMarketFilters().map((item) => (
                                            <MenuItem onClick={() => handleMarketMenuClose(item)} value={item}>
                                                <ListItemIcon>
                                                    <LocationOnIcon
                                                        fontSize="small"
                                                        sx={{ color: config.primaryColor }}
                                                    />
                                                </ListItemIcon>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Popper>
                                </Box>
                                <Box className="filter3" sx={{ ml: ".5rem" }}>
                                    <Button
                                        id="status-filter"
                                        aria-controls={statusOpen ? "status-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-describedby="status-menu"
                                        onClick={handleStatusMenuClick}
                                        sx={{ ...styles.outlinedButton }}
                                        className={filter?.status?.length > 0 ? "selected" : ""}
                                        variant="outlined"
                                        endIcon={
                                            filter.status?.length > 0 ? (
                                                <CloseIcon onClick={(event) => handleClear(event, "status")} />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )
                                        }
                                        startIcon={<AssignmentIcon sx={{ color: config.primaryColor }} />}>
                                        {`Status`}
                                    </Button>
                                    <Popper
                                        sx={{
                                            ...styles.popper,
                                            minWidth: "100px",
                                            maxWidth: "200px",
                                            zIndex: "1000",
                                            p: "1rem",
                                        }}
                                        id="status-menu"
                                        open={statusOpen}
                                        onClose={() => handleStatusClose("")}
                                        anchorEl={anchorStatusEl}>
                                        <Checklist
                                            options={getStatusFilters()}
                                            selectedValues={filter.status ? filter.status : []}
                                            hideLabel
                                            columns={1}
                                            onChange={(event, values) => handleStatusClose(values)}></Checklist>
                                    </Popper>
                                </Box>

                                <Box className="filter4" sx={{ ml: ".5rem" }}>
                                    <Button
                                        id="price-range"
                                        aria-controls={priceRangeOpen ? "price-range-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-describedby="price-range-menu"
                                        onClick={handlePriceRangeClick}
                                        sx={{ ...styles.outlinedButton, width: "155px" }}
                                        variant="outlined"
                                        className={filter.priceFilter?.length ? "selected" : ""}
                                        endIcon={
                                            filter.priceFilter?.length > 0 ? (
                                                <CloseIcon onClick={(event) => handleClear(event, "priceFilter")} />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )
                                        }
                                        startIcon={<AttachMoneyIcon sx={{ color: config.primaryColor }} />}>
                                        {`${
                                            filter.priceFilter?.length > 0
                                                ? convertNumberToShort(
                                                      filter.priceFilter[0] ? filter.priceFilter[0] : 0,
                                                      "$"
                                                  ) +
                                                  "-" +
                                                  convertNumberToShort(filter.priceFilter[1], "$")
                                                : "Rent Range"
                                        }`}
                                    </Button>
                                    <Popper
                                        sx={{ ...styles.popper, minWidth: "300px", p: "2rem", zIndex: "1000" }}
                                        id="price-range-menu"
                                        open={priceRangeOpen}
                                        onClose={() => handlePriceRangeClose("")}
                                        anchorEl={anchorPriceRangeEl}>
                                        <RangeSlider
                                            type="currency"
                                            multipleOf={100}
                                            defaultValue={filter.priceFilter}
                                            onChange={handlePriceRangeChange}></RangeSlider>
                                    </Popper>
                                </Box>
                                <Box className="filter2" sx={{ ml: ".5rem" }}>
                                    <Button
                                        id="lease-product-filter"
                                        aria-controls={leaseProductOpen ? "lease-product-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-describedby="lease-product-menu"
                                        onClick={handleLeaseProductMenuClick}
                                        sx={{ ...styles.outlinedButton }}
                                        className={filter?.leaseProduct?.length > 0 ? "selected" : ""}
                                        variant="outlined"
                                        endIcon={
                                            filter.leaseProduct?.length > 0 ? (
                                                <CloseIcon onClick={(event) => handleClear(event, "leaseProduct")} />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )
                                        }
                                        startIcon={<Inventory2Icon sx={{ color: config.primaryColor }} />}>
                                        {`Lease Type`}
                                    </Button>
                                    <Popper
                                        sx={{
                                            ...styles.popper,
                                            minWidth: "100px",
                                            maxWidth: "250px",
                                            zIndex: "1000",
                                            p: "1rem",
                                        }}
                                        id="lease-product-menu"
                                        open={leaseProductOpen}
                                        onClose={() => handleLeaseProductClose("")}
                                        anchorEl={anchorLeaseProductEl}>
                                        <Checklist
                                            options={getLeaseProductFilters()}
                                            selectedValues={filter.leaseProduct ? filter.leaseProduct : []}
                                            hideLabel
                                            columns={1}
                                            onChange={(event, values) => handleLeaseProductClose(values)}></Checklist>
                                    </Popper>
                                </Box>
                                <Box className="filter5" sx={{ ml: ".5rem" }}>
                                    <Button
                                        id="beds-baths-filter"
                                        aria-controls={bedBathOpen ? "beds-baths-menu" : undefined}
                                        aria-haspopup="true"
                                        aria-describedby="beds-baths-menu"
                                        onClick={handleBedBathClick}
                                        sx={{ ...styles.outlinedButton, width: "150px" }}
                                        className={filter.bedsFilter || filter.bathsFilter ? "selected" : ""}
                                        variant="outlined"
                                        endIcon={
                                            filter.bedsFilter || filter.bathsFilter ? (
                                                <CloseIcon onClick={(event) => handleClear(event, "bedsFilter")} />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )
                                        }
                                        startIcon={<BedroomChildIcon sx={{ color: config.primaryColor }} />}>
                                        {`${
                                            filter.bedsFilter || filter.bathsFilter
                                                ? (filter.bedsFilter ? filter.bedsFilter : 0) +
                                                  "+ bd / " +
                                                  (filter.bathsFilter ? filter.bathsFilter : 0) +
                                                  "+ ba"
                                                : "Beds / Baths"
                                        }`}
                                    </Button>
                                    <Popper
                                        sx={{ ...styles.popper, minWidth: "300px", zIndex: "1000" }}
                                        id="beds-baths-menu"
                                        open={bedBathOpen}
                                        anchorEl={anchorBedBathEl}>
                                        <Box>Beds</Box>
                                        <Box>
                                            <ToggleButtonGroup
                                                color="primary"
                                                value={filter.bedsFilter}
                                                exclusive
                                                onChange={handleBedsChange}
                                                aria-label="Platform">
                                                <ToggleButton value="">Any</ToggleButton>
                                                <ToggleButton value="1">1+</ToggleButton>
                                                <ToggleButton value="2">2+</ToggleButton>
                                                <ToggleButton value="3">3+</ToggleButton>
                                                <ToggleButton value="4">4+</ToggleButton>
                                                <ToggleButton value="5">5+</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box>
                                        <Box sx={{ mt: "1rem" }}>Baths</Box>
                                        <Box>
                                            <ToggleButtonGroup
                                                color="primary"
                                                value={filter.bathsFilter}
                                                exclusive
                                                onChange={handleBathsChange}
                                                aria-label="Platform">
                                                <ToggleButton value="">Any</ToggleButton>
                                                <ToggleButton value="1">1+</ToggleButton>
                                                <ToggleButton value="2">2+</ToggleButton>
                                                <ToggleButton value="3">3+</ToggleButton>
                                                <ToggleButton value="4">4+</ToggleButton>
                                                <ToggleButton value="5">5+</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box>
                                    </Popper>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Button
                                    id="market-filter"
                                    aria-haspopup="true"
                                    sx={{ ...styles.outlinedButton, ml: ".5rem" }}
                                    variant="outlined"
                                    onClick={() => handleAllFilterClick()}
                                    startIcon={<FilterIcon sx={{ color: config.primaryColor }} />}
                                    className={getFilterCount() > 0 ? "selected" : ""}>
                                    {`All filters` + (getFilterCount() > 0 ? " - " + getFilterCount() : "")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box
                        sx={{
                            mb: "20px",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: { xs: "flex", md: "none" },
                        }}>
                        <Box>
                            <Button
                                id="market-filter"
                                aria-haspopup="true"
                                sx={{ ...styles.outlinedButton }}
                                variant="outlined"
                                onClick={() => handleAllFilterClick()}
                                startIcon={<FilterIcon sx={{ color: config.primaryColor }} />}>
                                {`All filters`}
                            </Button>
                            <Box className="filter4" sx={{ ml: ".5rem" }}>
                                <Button
                                    id="lease-product-filter"
                                    aria-controls={leaseProductOpen ? "lease-product-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-describedby="lease-product-menu"
                                    onClick={handleLeaseProductMenuClick}
                                    sx={{ ...styles.outlinedButton }}
                                    className={filter?.leaseProduct?.length > 0 ? "selected" : ""}
                                    variant="outlined"
                                    endIcon={
                                        filter.leaseProduct?.length > 0 ? (
                                            <CloseIcon onClick={(event) => handleClear(event, "leaseProduct")} />
                                        ) : (
                                            <KeyboardArrowDownIcon />
                                        )
                                    }
                                    startIcon={<Inventory2Icon sx={{ color: config.primaryColor }} />}>
                                    {`Lease Type`}
                                </Button>
                                <Popper
                                    sx={{
                                        ...styles.popper,
                                        minWidth: "100px",
                                        maxWidth: "250px",
                                        zIndex: "1000",
                                        p: "1rem",
                                    }}
                                    id="lease-product-menu"
                                    open={leaseProductOpen}
                                    onClose={() => handleLeaseProductClose("")}
                                    anchorEl={anchorLeaseProductEl}>
                                    <Checklist
                                        options={getLeaseProductFilters()}
                                        selectedValues={filter.leaseProduct ? filter.leaseProduct : []}
                                        hideLabel
                                        columns={1}
                                        onChange={(event, values) => handleLeaseProductClose(values)}></Checklist>
                                </Popper>
                            </Box>
                        </Box>

                        <Box sx={{ display: { xs: "block", md: "none" } }}>{propertyCount} homes</Box>
                    </Box>
                </>
                <Drawer anchor={"right"} open={displayAllFilter} sx={{ position: "relative", zIndex: "10000" }}>
                    <Box sx={{ width: { xs: "320px", md: "640px" } }} onClick={handleSelectClose}>
                        <Grid
                            container
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            sx={{
                                padding: ".5rem 1.2rem",
                                borderBottom: config.border,
                                position: "absolute",
                                width: "100%",
                                left: "0",
                                top: "0",
                            }}>
                            <Grid item xs={10}>
                                <Box sx={{ ...styles.cardHeading }}>Filters</Box>
                                <Box sx={{ ...styles.subHeading }}>
                                    Select filters and click “Apply” to see results.
                                </Box>
                            </Grid>
                            <Grid item>
                                <CloseIcon onClick={() => setDisplayAllFilter(false)} fontSize="small"></CloseIcon>
                            </Grid>
                        </Grid>
                        <Box
                            sx={{
                                position: "absolute",
                                width: "100%",
                                left: "0",
                                top: "70px",
                                height: "calc(100vh - 140px)",
                                bottom: "70px",
                                overflow: "auto",
                                paddingBottom: "30px",
                            }}>
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Market</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <FormControl fullWidth sx={{ position: "relative" }}>
                                        <Select
                                            labelId="market-select-label"
                                            id="market-select"
                                            value={
                                                localFilter.market
                                                    ? localFilter.market
                                                    : filter.market
                                                    ? filter.market
                                                    : "-"
                                            }
                                            label=""
                                            IconComponent={localFilter.market ? "" : ArrowDropDownIcon}
                                            renderValue={(selected) => {
                                                if (selected === "-") {
                                                    return <em style={{ color: "gray" }}>Select Market</em>;
                                                }

                                                return selected;
                                            }}
                                            open={selectOpen.market ? selectOpen.market : false}
                                            onClick={(event) => handleSelectClick(event, "market")}
                                            onClose={handleSelectClose}
                                            endAdornment={
                                                localFilter.market &&
                                                false && (
                                                    <IconButton
                                                        onClick={(event) =>
                                                            handleLocalFilterChange(event, "", "market")
                                                        }>
                                                        <CloseIcon />
                                                    </IconButton>
                                                )
                                            }>
                                            <MenuItem disabled value="">
                                                <em>Select Market</em>
                                            </MenuItem>
                                            {getMarketFilters().map((item) => (
                                                <MenuItem
                                                    onClick={(event) => handleLocalFilterChange(event, item, "market")}
                                                    value={item}>
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Status</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <Checklist
                                        options={getStatusFilters()}
                                        selectedValues={
                                            localFilter.status ? localFilter.status : filter.status ? filter.status : []
                                        }
                                        hideLabel
                                        columns={2}
                                        onChange={(event, values) =>
                                            handleLocalFilterChange(event, values, "status")
                                        }></Checklist>
                                </Box>
                            </Box>

                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Monthly rent range</Box>
                                <Box sx={{ margin: "8px 0px", padding: "0 1rem" }}>
                                    <RangeSlider
                                        type="currency"
                                        multipleOf={100}
                                        defaultValue={localFilter.priceFilter ? localFilter.priceFilter : ""}
                                        onChange={(event, newValue) =>
                                            handleLocalFilterChange(event, newValue, "priceFilter")
                                        }></RangeSlider>
                                </Box>
                            </Box>
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Lease type</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <Checklist
                                        options={getLeaseProductFilters()}
                                        selectedValues={
                                            localFilter.leaseProduct
                                                ? localFilter.leaseProduct
                                                : filter.leaseProduct
                                                ? filter.leaseProduct
                                                : []
                                        }
                                        hideLabel
                                        columns={1}
                                        onChange={(event, values) =>
                                            handleLocalFilterChange(event, values, "leaseProduct")
                                        }></Checklist>
                                </Box>
                            </Box>
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Beds</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <Box>
                                        <ToggleButtonGroup
                                            fullWidth
                                            color="primary"
                                            value={localFilter.bedsFilter ? localFilter.bedsFilter : ""}
                                            exclusive
                                            onChange={(event, newValue) =>
                                                handleLocalFilterChange(event, newValue, "bedsFilter")
                                            }
                                            aria-label="Platform">
                                            <ToggleButton value="">Any</ToggleButton>
                                            <ToggleButton value="1">1+</ToggleButton>
                                            <ToggleButton value="2">2+</ToggleButton>
                                            <ToggleButton value="3">3+</ToggleButton>
                                            <ToggleButton value="4">4+</ToggleButton>
                                            <ToggleButton value="5">5+</ToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Baths</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <Box>
                                        <ToggleButtonGroup
                                            fullWidth
                                            color="primary"
                                            value={localFilter.bathsFilter ? localFilter.bathsFilter : ""}
                                            exclusive
                                            onChange={(event, newValue) =>
                                                handleLocalFilterChange(event, newValue, "bathsFilter")
                                            }
                                            aria-label="Platform">
                                            <ToggleButton value="">Any</ToggleButton>
                                            <ToggleButton value="1">1+</ToggleButton>
                                            <ToggleButton value="2">2+</ToggleButton>
                                            <ToggleButton value="3">3+</ToggleButton>
                                            <ToggleButton value="4">4+</ToggleButton>
                                            <ToggleButton value="5">5+</ToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                </Box>
                            </Box>
                            {/* {amenityAndFeaturesOptions?.length > 0 && (
                                <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                    <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Amenity and Features</Box>
                                    <Box sx={{ margin: "8px 0px" }}>
                                        <Box>
                                            <Checklist
                                                options={amenityAndFeaturesOptions}
                                                selectedValues={
                                                    localFilter.amenityAndFeatures
                                                        ? localFilter.amenityAndFeatures
                                                        : filter.amenityAndFeatures
                                                            ? filter.amenityAndFeatures
                                                            : []
                                                }
                                                hideLabel
                                                columns={2}
                                                onChange={(event, values) =>
                                                    handleLocalFilterChange(event, values, "amenityAndFeatures")
                                                }
                                            ></Checklist>
                                        </Box>
                                    </Box>
                                </Box>
                            )} */}
                            <Box sx={{ padding: ".5rem 1.2rem", borderBottom: config.border }}>
                                <Box sx={{ ...styles.cardHeading, fontSize: "16px" }}>Property Details</Box>
                                <Box sx={{ margin: "8px 0px" }}>
                                    <Grid container spacing={3}>
                                        <Grid xs={12} md={6}>
                                            <Box>
                                                <RangePicklist
                                                    options={getSquareFtOptions()}
                                                    value={
                                                        localFilter.squareFt
                                                            ? localFilter.squareFt
                                                            : filter.squareFt
                                                            ? filter.squareFt
                                                            : {}
                                                    }
                                                    label="Square feet"
                                                    columns={2}
                                                    onChange={(event, values) =>
                                                        handleLocalFilterChange(event, values, "squareFt")
                                                    }></RangePicklist>
                                            </Box>
                                        </Grid>
                                        <Grid xs={12} md={6}>
                                            <Box>
                                                <RangePicklist
                                                    options={getLotSqFTOptions()}
                                                    value={
                                                        localFilter.lotSize
                                                            ? localFilter.lotSize
                                                            : filter.lotSize
                                                            ? filter.lotSize
                                                            : {}
                                                    }
                                                    label="Lot size"
                                                    columns={2}
                                                    onChange={(event, values) =>
                                                        handleLocalFilterChange(event, values, "lotSize")
                                                    }></RangePicklist>
                                            </Box>
                                        </Grid>
                                        <Grid xs={12} md={6}>
                                            <Box>
                                                <RangePicklist
                                                    options={getStoriesOptions()}
                                                    value={
                                                        localFilter.stories
                                                            ? localFilter.stories
                                                            : filter.stories
                                                            ? filter.stories
                                                            : {}
                                                    }
                                                    label="Stories"
                                                    columns={2}
                                                    onChange={(event, values) =>
                                                        handleLocalFilterChange(event, values, "stories")
                                                    }></RangePicklist>
                                            </Box>
                                        </Grid>
                                        <Grid xs={12} md={6}>
                                            <Box>
                                                <RangePicklist
                                                    options={getYearBuildOptions()}
                                                    value={
                                                        localFilter.yearBuilt
                                                            ? localFilter.yearBuilt
                                                            : filter.yearBuilt
                                                            ? filter.yearBuilt
                                                            : {}
                                                    }
                                                    label="Year built"
                                                    columns={2}
                                                    onChange={(event, values) =>
                                                        handleLocalFilterChange(event, values, "yearBuilt")
                                                    }></RangePicklist>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Box>
                        <Grid
                            container
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            sx={{
                                padding: ".5rem 1.2rem",
                                borderTop: config.border,
                                position: "absolute",
                                width: "100%",
                                left: "0",
                                bottom: "0",
                                background: "#fff",
                            }}>
                            <Grid item>
                                <Button onClick={handleResetAllFilter}>Reset All</Button>
                            </Grid>
                            <Grid item>
                                <Button onClick={handleCancelLocalFilter} variant="outlined">
                                    Cancel
                                </Button>
                                <Button onClick={handleApplyLocalFilter} sx={{ ml: ".5rem" }} variant="contained">
                                    Apply
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Drawer>
            </div>
        </ClickAwayListener>
    );
};

export default Filters;
